export default class ObjectUtils {
    static keys(obj) {
        return Object.keys(obj);
    }
    static values(obj) {
        return Object.values(obj);
    }
    static keysWithDefinedValues(obj) {
        const keys = ObjectUtils.keys(obj);
        return keys.filter((key) => obj[key] !== undefined);
    }
}
//# sourceMappingURL=ObjectUtils.js.map